
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import UseCustomerDropDownNew from '../../../../Components/Hooks/useCustomerSearch';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import { useToast } from '../../../../Components/Others/ToastServices';
import useEditFormData from '../../../../Components/Hooks/useEditFormData';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate, NuInput, NuTextArea, NuTime } from '../../../../Components/Utils/Input';
import MultiSelect from '../../../../Components/Utils/MultiSelect';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import CloseIcon from '../../../../Components/Icons/Close';
import { videotype } from './viewFiles';
import Video from '../../../../Components/Icons/Video';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import { Modal } from 'antd';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';

const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];


function EditTask() {
  const navigate = useNavigate();
  const [image, setImage] = useState([]);
    
        const [selectedFile, setSelectedFile] = useState(null);
         const [filePathList, setFilePathList] = useState([]);
         const [fileRemoveList, setFileRemoveList] = useState([]);
                const [removefilePathList, setRemoveFilePathList] = useState([]);
                const [selectedImage, setSelectedImage] = useState(null);
                       const [fileExtention, setFileExtention] = useState("");
                              const [isModalOpen, setIsModalOpen] = useState(false);
                             const [searchClient, setSearchClient] = useState("");
                       
                              const { data: client, setDataCustomer } = UseCustomerDropDownNew(
                                "/clients/drop-down",
                                searchClient
                              );
                              const { value: Priority,getData:refPriority } = useFetchMataData(
                                `/dropdown/dropdown-details/`,
                                "priority"
                              ); 
                              const { data: user } = UseDropDown(`/user/new-drop-down`);
                              const { value: Status, getData: refStatus } = useFetchMataData(
                               `/dropdown/dropdown-details/`,
                               "Status_Task"
                             );
                             const { value: Type, getData: refType } = useFetchMataData(
                                  `/dropdown/dropdown-details/`,
                                  "Type_Schedules"
                                );
                                
                             
                const toast = useToast();
         
    const location = useLocation();
    // const data = location.state.data;

    // const cData = location.state?.data;
    const { alltasksEditId } = useParams();
    
     const [data,setData] = useState(null); 
     
    
     
   
   
    
  const from = location.state.from;

  const {  editFormData , isLoading} =useEditFormData(); 
     const [createNew, setCreateNew] = useState([]);
  function getView() {
    axiosInstance 
      .get(`/tasks/${alltasksEditId}`)
      .then((res) => {
        res?.data?.data && setData(res?.data?.data);
      
      
        setCreateNew({
         taskName: res?.data?.data?.taskName  || "",
         taskDesc: res?.data?.data?.taskDesc  || "",
       priority: res?.data?.data?.priority  || "",
       startDate: res?.data?.data?.startDate  || null,
       endDate: res?.data?.data?.endDate  || null,
       completeDate: res?.data?.data?.completeDate  || "",
       taskStatus: res?.data?.data?.taskStatus|| "",
       noOfDays: res?.data?.data?.noOfDays  || "",
       noOfWeeks: res?.data?.data?.noOfWeeks  || "",
       scopeOfWork: res?.data?.data?.scopeOfWork  || "",
          refNo: res?.data?.data?.refNo  || "",
       reminderDate: res?.data?.data?.reminderDate  || null,
       reminderTime: res?.data?.data?.reminderTime  || null,
       revisedEndDate: res?.data?.data?.revisedEndDate  || "",
       assignedTo: res?.data?.data?.assignedTo.map((it)=>it.id)  || "",
       reAssignedTo: res?.data?.data?.reAssignedTo  || "",
       copyTo: res?.data?.data?.copyTo.map((it)=>it.id)  || "",
   
       filesToRemove:[]
        });       
      })
      .catch(err=>{
        console.log("err", err);
      })
  }
  
  useEffect(() => {
    // if (!cData) {
      getView();
    // }
  }, [])

  
const formik = useFormik({
      enableReinitialize: true,
      initialValues: createNew,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // phone: yup
        //   .string()
        //   .matches(/^\d+$/, "Phone number must contain only digits")
        //   .min(9, "Phone number must be at least 9 digits")
        //   .max(11, "Phone number must be at most 11 digits")
        //   .required("Phone number is required"),
        //   cPMobile: yup
        //   .string()
        //   .matches(/^\d+$/, "Phone number must contain only digits")
        //   .min(9, "Phone number must be at least 9 digits")
        //   .max(11, "Phone number must be at most 11 digits")
        //   .required("Contact Phone number is required"),
        // email: yup.string().required("Email is required!"),
        // companyName: yup.string().required("Company Name is required!"),
        // // website: yup.string().required("Website is required!"),
        // cpName: yup.string().required("Contact Person is required!"),
      }),
      onSubmit: async (value, { resetForm }) => {
        const { startDate, endDate } = value;
      
        if (!startDate || !endDate) {
          toast.open({ type: "warning", message: "Start Date and End Date are required." });
          return;
        }
      
        const start = new Date(startDate);
        const end = new Date(endDate);
      
        if (end <= start) {
          toast.open({ type: "error", message: "End Date must be after Start Date." });
          return;
        }
      
        // continue your form submission if dates are valid
        let formData = new FormData();
        const valueWithProducts = {
          ...value,
          filesToRemove: fileRemoveList,
        };
      
        formData.append("json_data", JSON.stringify(valueWithProducts));
      
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("attachments", file);
          });
        } else {
          formData.append("attachments", []);
        }
                         await editFormData({url:`/tasks/edit-task/${alltasksEditId}`,formData:formData,navigateUrl:from ||`/tasks/all-tasks`,resetForm:resetForm   })

        // editFormData(`/tasks/edit-task/${alltasksEditId}`, formData, resetForm, from);
      }
    });
 
      function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
       
         useEffect(() => {
           if (
             data?.attachment !== null &&
             data?.attachment !== "None" &&
             data?.attachment !== "[]"
           ) {
             setFilePathList(data?.attachment);
       
             setRemoveFilePathList(data?.attachment || []);
           }
         }, [data]);
       
         function UpdateAttachmentList(item) {
           let filterList = filePathList.filter((itemList) => itemList.file !== item);
           let removeFile = filePathList.find((itemList) => itemList.file === item);
           console.log("llll", filterList);
           setFileRemoveList([...fileRemoveList, removeFile.file]);
           setFilePathList(filterList);
         }
       
         function handleImageClick(img) {
           let Ext = img?.file_name.split(".").reverse()[0];
           setSelectedImage(img);
           setFileExtention(Ext);
           setIsModalOpen(true);
         } 
 
         useEffect(() => {
          if (formik.values.startDate && formik.values.endDate) {
            const startDate = new Date(formik.values.startDate);
            const endDate = new Date(formik.values.endDate);
        
            if (endDate > startDate) {
              const diffDays = Math.ceil(Math.abs(endDate - startDate) / (1000 * 60 * 60 * 24));
              const diffWeeks = Math.ceil(diffDays / 7);
        
              formik.setFieldValue("noOfDays", diffDays);
              formik.setFieldValue("noOfWeeks", diffWeeks);
            } else {
              formik.setFieldValue("noOfDays", 0);
              formik.setFieldValue("noOfWeeks", 0);
            }
          }
        }, [formik.values.startDate, formik.values.endDate]);
  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full "> 
         <Breadcrumb
                  items={[
                       {   name: "All Task" ,
                      link:"/tasks/all-tasks"
                    },
                    { name: "Edit" },
                  ]}
                />     
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
        <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
        
          <SettingHeading title={`All Task : ${createNew?.refNo}` } />
                 
            </div>
             <NuInput
              label="Task Description"
              type="text"
              formik={formik}
              placeholder="Task Description"
              name="taskDesc"
              width="w-full md:w-[66%] md:-mt-2"
              displayProperty={"Type"}
              propertyName={"Type_Schedules"}
              getFunc={refType}
              // isRequired={true}

            />
              {/* <NuInput
                label="Task "
                type="text"
                formik={formik}
                placeholder="Task "
                name="taskName"
                width="w-full md:w-1/3 md:-mt-2"
                displayProperty={"Type"}
                propertyName={"Type_Schedules"}
                getFunc={refType}
                // isRequired={true}
            
                    /> */}
            
            <MultiSelect
              label="Assigned To"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignedTo"

              width="w-full md:w-1/3 md:-mt-2"
            />
             <MultiSelect
              label="Copy To"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="copyTo"

              width="w-full md:w-1/3 md:-mt-2"
            />

            <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"
              // isRequired={true}

              width="w-full md:w-1/3 md:-mt-2"
            />
                   {/* <NuDate
  label="Start Date"
  placeholder="Start Date"
  formik={formik}
  name="startDate"
  width="w-full md:w-1/3 md:-mt-2"
  min={new Date().toISOString().split("T")[0]} // today
/> */}

<NuDate
  label="Start Date"
  placeholder="Start Date"
  formik={formik}
  name="startDate"
  width="w-full md:w-1/3 md:-mt-2"
  min={
    formik.initialValues.startDate
      ? new Date(formik.initialValues.startDate).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0]
  }
/>



<NuDate
  label="Due Date"
  placeholder="Due Date"
  formik={formik}
  name="endDate"
  width="w-full md:w-1/3 md:-mt-2"
  min={formik.values.startDate || new Date().toISOString().split("T")[0]}
  disabled={!formik.values.startDate}
/>

<NuDate
  label="Completion Date"
  placeholder="Completion Date"
  formik={formik}
  name="completeDate"
  width="w-full md:w-1/3 md:-mt-2"
  min={formik.values.startDate}
  max={formik.values.endDate}
  disabled={!formik.values.startDate}
/>

             <NuInput
              label="Number Of Days"
             type="number"
              formik={formik}
              disabled={true}
              placeholder="0"
              name="noOfDays"
              // isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              label="Number Of Weeks"
             type="number"
              formik={formik}
               disabled={true}
              placeholder="0"
              name="noOfWeeks"
              // isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
  label="Reminder Date"
  placeholder="Date"
  formik={formik}
  name="reminderDate"
  width="w-full md:w-1/3 md:-mt-2"
  min={new Date().toISOString().split("T")[0]}
  max={formik.values.endDate}
  disabled={!formik.values.startDate}
/>
              <NuTime
              label="Reminder Time"
              placeholder="Date"
              formik={formik}
              name="reminderTime"
             
              width="w-full md:w-1/3 md:-mt-2"
            />

            
                    <DropDownAddMetaData
                          label="Status"
                          Options={Status}
                          formik={formik}
                          placeholder="Choose"
                          name="taskStatus"
                          // isRequired={true}
            
                          width="w-full md:w-1/3 md:-mt-2"
                          displayProperty={"Status"}
                          propertyName={"Status_Task"}
                             getFunc={refStatus}
            
                        />
                        <NuTextArea
                                      type="text"
                                      label="Scope of Work"
                                      placeholder="Scope of Work"
                                      formik={formik}
                                      name="scopeOfWork"
                                      // new_width='w-full md:w-1/2'
                                      width="w-full md:w-1/3 md:-mt-2"
                                    />

<div className="w-full">
                                           <SettingHeading title="Attachments"  />
                  
                  <Attachement 
                      handleChange={handleImageChange}
                      preview={image || ""}
                      width="w-full md:w-1/2"
                      label="Attach"
                      multiple={true}
                removeImages={removeImages}

                    />
                </div>
                <div className="md:flex justify-between mt-5 px-3 w-full">
                  <div className="w-full flex gap-2 items-center flex-wrap">
                    {filePathList &&
                      filePathList?.map((imgs, idx) => {
                        console.log("img", imgs);
                        let Ext = imgs?.file_name.split(".").reverse()[0];
                        return (
                          <div
                            className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                            key={idx}
                            style={{
                              border: "1px solid gray",
                              borderColor:
                                "rgb(148 163 184 / var(--tw-bg-opacity))",
                            }}
                          >
                            <div
                              className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                              onClick={() => UpdateAttachmentList(imgs?.file)}
                            >
                              <CloseIcon color="white" height="8" width="8" />
                            </div>
                            <div
                              className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                              onClick={() => handleImageClick(imgs)}
                            >
                              <div className=" w-8 h-8">
                                {videotype.includes(Ext) ? <Video /> : null}
  
                                {Ext === ("docx" || "doc" || "txt") ? (
                                  <Doc />
                                ) : Ext === ("xlsx" || "xls") ? (
                                  <Xls />
                                ) : Ext === "txt" ? (
                                  <Txt />
                                ) : Ext === "pdf" ? (
                                  <Pdf />
                                ) : Ext === "PDF" ? (
                                  <Pdf />
                                ) : Ext === "pptx" ? (
                                  <>No file</>
                                ) : (
                                  <img src={imgs?.file} alt="#" width="120%" />
                                )}
                              </div>
                              <p className=" w-[50px] text-[11px] truncate">
                                {imgs?.file_name}
                              </p>
                            </div>
                          </div>
                        );
                      })}
  
                  
                  </div>
                </div>
           
           
            <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <img src={selectedImage?.file} alt={selectedImage?.file} />
              </Modal>
    </div>
  );
}

export default EditTask
